module.exports = __webpack_public_path__ + "media/images/member/328x350-1e989f4704cb50054af7de0ce7a53d5d.png";